/**
 * ==========================================================================
 * OBSIDIAN CUSTOM — Bascule automatique du sélecteur de variantes
 * ==========================================================================
 *
 * Contexte : sur les fiches produit à matrice de variantes creuse (certaines
 * combinaisons n'existent pas), le thème Stretch re-rend la section à chaque
 * changement d'option (Section Rendering API, ?option_values=...). Côté Liquid,
 * variant-picker.liquid masque déjà les valeurs d'option INEXISTANTES dans la
 * sélection courante. Mais si l'utilisateur choisit une valeur qui rend la
 * sélection courante impossible (ex. Zircon=Noir alors que Couleur=Titane, et
 * Noir n'existe qu'en Gold), le thème enverrait une combinaison invalide →
 * variante non résolue (prix/panier cassés) et masquage en cascade.
 *
 * Ce script empêche cet état : en phase de CAPTURE (avant le handler délégué du
 * thème posé sur document.body), si la sélection résultante n'existe pas, on
 * corrige les AUTRES options vers la première combinaison existante qui préserve
 * au mieux le choix de l'utilisateur. Le thème lit ensuite l'état des <input>
 * cochés (form.elements) et fetch directement la bonne combinaison. Aucune
 * requête invalide, pas de double fetch, pas de flash.
 *
 * Données : matrice émise par snippets/obsidian-variant-matrix.liquid dans
 * <variant-picker> (script[data-obsidian-variant-matrix]).
 *
 * Robustesse : idempotent (garde globale), no-op si pas de matrice, bail sur les
 * "combined listings" (valeurs pointant vers un autre produit via data-product-url).
 * ==========================================================================
 */
(function () {
  'use strict';

  if (window.__obsidianVariantSmartInit) return;
  window.__obsidianVariantSmartInit = true;

  function parseMatrix(picker) {
    var script = picker && picker.querySelector('script[data-obsidian-variant-matrix]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  // form.elements inclut les <input> associés au formulaire même s'ils sont
  // déplacés hors du sous-arbre DOM (les popovers des dropdowns sont portalisés).
  function optionInputs(form) {
    var out = [];
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el && el.matches && el.matches('input[data-option-position]')) out.push(el);
    }
    return out;
  }

  function currentSelection(inputs, positions) {
    var sel = new Array(positions).fill(null);
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].checked) continue;
      var pos = parseInt(inputs[i].getAttribute('data-option-position'), 10);
      if (pos >= 1 && pos <= positions) sel[pos - 1] = inputs[i].value;
    }
    return sel;
  }

  function tupleMatches(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  function tupleExists(variants, tuple) {
    for (var i = 0; i < variants.length; i++) {
      if (tupleMatches(variants[i].v, tuple)) return true;
    }
    return false;
  }

  function tupleComplete(v) {
    for (var i = 0; i < v.length; i++) {
      if (!v[i]) return false;
    }
    return true;
  }

  function orderIndex(order, pos, val) {
    var arr = order && order[pos];
    if (!arr) return 0;
    var idx = arr.indexOf(val);
    return idx < 0 ? 999 : idx;
  }

  function findInput(inputs, pos, val) {
    var target = String(pos);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-option-position') === target && inputs[i].value === val) {
        return inputs[i];
      }
    }
    return null;
  }

  // Garde-fou : la valeur corrective peut avoir été RETIRÉE du DOM par le masquage
  // Liquid (elle n'existait pas avec la sélection PRÉCÉDENTE). Sans input à cocher,
  // la correction échouerait en silence et le thème partirait sur une combinaison
  // invalide. On synthétise alors un radio équivalent : même form owner + même name
  // => il rejoint le groupe et décoche automatiquement la valeur en cours. Le thème
  // lit form.elements (collection vivante) en phase bubbling, donc juste après.
  // Le re-render de section qui suit le remplace par le vrai input rendu par Liquid.
  // Aucun cas du catalogue actuel n'emprunte ce chemin (matrices creuses vérifiées) :
  // c'est une assurance pour les futures fiches à combinaisons manquantes.
  function ghostInput(inputs, formId, pos, val) {
    var target = String(pos);
    var sibling = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-option-position') === target) {
        sibling = inputs[i];
        break;
      }
    }
    if (!sibling || !sibling.name || !sibling.parentNode) return null;

    var ghost = document.createElement('input');
    ghost.type = 'radio';
    ghost.className = 'sr-only';
    ghost.hidden = true;
    ghost.name = sibling.name;
    ghost.value = val;
    ghost.setAttribute('form', formId);
    ghost.setAttribute('data-option-position', target);
    ghost.setAttribute('data-obsidian-ghost', '');
    sibling.parentNode.insertBefore(ghost, sibling);
    return ghost;
  }

  function clearGhosts() {
    var stale = document.querySelectorAll('input[data-obsidian-ghost]');
    for (var i = 0; i < stale.length; i++) {
      if (stale[i].parentNode) stale[i].parentNode.removeChild(stale[i]);
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('input[data-option-position]')) return;

    var formId = target.getAttribute('form') || (target.form && target.form.id);
    if (!formId) return;
    var form = document.forms[formId] || target.form;
    if (!form) return;

    var esc = (window.CSS && CSS.escape) ? CSS.escape(formId) : formId;
    var picker = document.querySelector('variant-picker[form-id="' + esc + '"]');
    if (!picker) return;

    var matrix = parseMatrix(picker);
    if (!matrix || !matrix.variants || !matrix.variants.length || !matrix.positions) return;

    clearGhosts();

    var positions = matrix.positions;
    var inputs = optionInputs(form);

    // Combined listing → laisser le thème gérer le changement de produit.
    for (var c = 0; c < inputs.length; c++) {
      if (inputs[c].hasAttribute('data-product-url')) return;
    }

    var sel = currentSelection(inputs, positions);
    if (!tupleComplete(sel)) return; // sélection incomplète : ne rien forcer

    // Combinaison valide → laisser le thème faire son fetch normal.
    if (tupleExists(matrix.variants, sel)) return;

    var clickedPos = parseInt(target.getAttribute('data-option-position'), 10);
    var clickedIdx = clickedPos - 1;
    var clickedVal = target.value;

    // Candidats : variantes existantes contenant la valeur cliquée (choix sacré).
    var candidates = matrix.variants.filter(function (variant) {
      return tupleComplete(variant.v) && variant.v[clickedIdx] === clickedVal;
    });
    if (!candidates.length) return;

    candidates.sort(function (a, b) {
      // 1. Préserver le maximum des AUTRES choix courants de l'utilisateur.
      var pa = 0, pb = 0;
      for (var i = 0; i < positions; i++) {
        if (i === clickedIdx) continue;
        if (a.v[i] === sel[i]) pa++;
        if (b.v[i] === sel[i]) pb++;
      }
      if (pa !== pb) return pb - pa;
      // 2. Préférer une variante disponible (en stock).
      if (a.a !== b.a) return a.a ? -1 : 1;
      // 3. Départager par ordre d'affichage des valeurs d'option (première dispo).
      var oa = 0, ob = 0;
      for (var k = 0; k < positions; k++) {
        oa += orderIndex(matrix.order, k, a.v[k]);
        ob += orderIndex(matrix.order, k, b.v[k]);
      }
      return oa - ob;
    });

    var best = candidates[0];

    // Applique la correction aux AUTRES options (l'option cliquée reste inchangée).
    // On ne dispatch AUCUN event : le thème lit l'état coché en phase bubbling.
    for (var p = 0; p < positions; p++) {
      if (best.v[p] === sel[p]) continue;
      var input = findInput(inputs, p + 1, best.v[p]) || ghostInput(inputs, formId, p + 1, best.v[p]);
      if (input) input.checked = true;
    }
  }

  // Capture : s'exécute avant le handler délégué du thème (bubbling sur document.body).
  document.addEventListener('change', handleChange, true);
})();
